import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'app';
  profile: any;

  constructor(public auth: AuthService) {
    // auth.handleAuthentication();
    var profile_text = localStorage.getItem('profile');
    if (profile_text) {
      this.profile = JSON.parse(profile_text);
    }
    this.auth.onProfileUpdated.subscribe(newProfile => {
      this.profile = newProfile;
    });
  }

  ngOnInit() {


  }
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/app.component.ts